import { gql } from 'graphql-request';
import { useQuery } from 'react-query';
import { InvoiceModel, getInvoiceReceipt, getRefundReceipt } from '@frontend/api-invoices';
import { usePaymentsGraphqlClient } from '../../utils/payment-graphql-client';

export const useFetchPaymentReceipt = (invoice?: InvoiceModel) => {
  return useQuery(
    ['invoiceReceipt', invoice?.payment?.paymentId],
    () => {
      if (!invoice) return;
      return getInvoiceReceipt(invoice);
    },
    {
      staleTime: Infinity,
      cacheTime: 30 * 60 * 1000, // 30 min,
      enabled: !!invoice?.payment,
      onError: (error) => error,
      refetchOnWindowFocus: false,
    }
  );
};

export const useFetchRefundReceipt = (paymentId: string, refundId: string) => {
  return useQuery(
    ['refundReceipt', refundId],
    () => {
      if (!paymentId || !refundId) return;

      return getRefundReceipt(paymentId, refundId);
    },
    {
      staleTime: Infinity,
      cacheTime: 30 * 60 * 1000, // 30 min,
      enabled: !!paymentId && !!refundId,
      onError: (error) => error,
      refetchOnWindowFocus: false,
    }
  );
};

const SEND_REFUND = gql`
  mutation SendRefundReceiptEmail($input: SendRefundReceiptEmailInput!) {
    sendRefundReceiptEmail(input: $input)
  }
`;

export const useSendRefundReceipt = ({
  locationId,
  paymentId,
  externalId,
  userId,
  invoiceId,
}: {
  locationId: string;
  paymentId?: string;
  externalId?: string;
  userId?: string;
  invoiceId?: string;
}) => {
  const { client } = usePaymentsGraphqlClient();

  const sendRefundReceipt = async (email: string) => {
    const variables = {
      input: {
        paymentId,
        externalId,
        locationId,
        emailAddress: email,
        userId,
        invoiceId,
      },
    };
    return await client.request(SEND_REFUND, variables);
  };

  return { sendRefundReceipt };
};
